import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { resolveClothingItemNameKey } from '../pipes/clothing-item-name-key.helper';
import {
  AppNotification,
  ClothingNotificationMessageParams
} from './clothing-notification-routing.service';

const CLOTHING_NOTIFICATION_DETAILS_KEY = 'CLOTHING_NOTIFICATION_DETAILS';
const CLOTHING_NOTIFICATION_MARKER = 'CLOTHING';
const CLOTHING_NOTIFICATION_CATEGORY = 'CLOTHING';

interface ClothingNotificationDisplayParams {
  [key: string]: string | number | string[];
}

@Injectable()
export class ClothingNotificationDisplayService {
  constructor(private translate: TranslateService) {
  }

  resolveText(notification: AppNotification): string {
    if (this.hasStructuredMessage(notification)) {
      return this.resolveStructuredText(notification);
    }
    if (this.hasDescription(notification)) {
      return notification.description;
    }
    return this.translate.instant(CLOTHING_NOTIFICATION_DETAILS_KEY);
  }

  private resolveStructuredText(notification: AppNotification): string {
    return this.translate.instant(
      notification.messageKey,
      this.localizeParams(notification.messageParams)
    );
  }

  private hasStructuredMessage(notification: AppNotification): boolean {
    return this.isClothingNotification(notification) && !!notification.messageKey;
  }

  private isClothingNotification(notification: AppNotification): boolean {
    if (!notification) {
      return false;
    }
    if (notification.notificationMarker === CLOTHING_NOTIFICATION_MARKER) {
      return true;
    }
    return notification.category === CLOTHING_NOTIFICATION_CATEGORY;
  }

  private hasDescription(notification: AppNotification): boolean {
    return !!notification && !!notification.description && !!notification.description.length;
  }

  private localizeParams(params: ClothingNotificationMessageParams): ClothingNotificationDisplayParams {
    var localizedParams = this.copyParams(params);
    this.localizeCatalogItemName(params, localizedParams);
    this.localizeCatalogItemNames(params, localizedParams);
    return localizedParams;
  }

  private copyParams(params: ClothingNotificationMessageParams): ClothingNotificationDisplayParams {
    var copy: ClothingNotificationDisplayParams = {};
    if (!params) {
      return copy;
    }
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        copy[key] = params[key];
      }
    }
    return copy;
  }

  private localizeCatalogItemName(
    params: ClothingNotificationMessageParams,
    localizedParams: ClothingNotificationDisplayParams
  ): void {
    if (!params || !params.catalogItemName) {
      return;
    }
    localizedParams.catalogItemName = this.translateItemName(params.catalogItemName);
  }

  private localizeCatalogItemNames(
    params: ClothingNotificationMessageParams,
    localizedParams: ClothingNotificationDisplayParams
  ): void {
    if (!params || !params.catalogItemNames || !params.catalogItemNames.length) {
      return;
    }
    localizedParams.catalogItemNames = this.translateItemNames(params.catalogItemNames);
  }

  private translateItemName(name: string): string {
    return this.translate.instant(resolveClothingItemNameKey(name));
  }

  private translateItemNames(names: string[]): string {
    return names.map((name: string) => {
      return this.translateItemName(name);
    }).join(', ');
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/clothing-notification-display.service.ts